export default "__VITE_ASSET__D3rEpRd9__"